<template>
    <h1>Mapa de Férias</h1>
    <AbsenceRequestGantTimeline />
</template>
<script setup>
import AbsenceRequestGantTimeline from "@/components/absences/requests/AbsenceRequestGantTimeline.vue"

</script>